<dialog-gala (clickClose)="dialogRef.close()">
    <span gala-dialog-titre>{{titre}}</span>
    <div class="row">
        <div class="col-md-12">
            <h3>Versions déployées</h3>
            <br />
            <mat-list>
                <mat-list-item>
                    <p>
                        <i class="fas fa-globe"></i>
                        &nbsp;
                        <span>Portail web : <b>{{version?.web}}</b></span>
                    </p>
                </mat-list-item>
                <mat-list-item>
                    <p>
                        <i class="fas fa-cog"></i>
                        &nbsp;
                        <span>Service web : <b>{{version?.ws}}</b></span>
                    </p>
                </mat-list-item>
            </mat-list>
            <br />
            <div class="text-center">
                <button mat-raised-button color="primary" (click)="telecharger()">
                    Télécharger le bulletin de livraisons
                </button>
            </div>
        </div>
    </div>
</dialog-gala>